// extracted by mini-css-extract-plugin
export var linkedInFollowButton = "linkedInFollowButton-module--linkedInFollowButton--8655c";
export var linkedInFollowButton__box = "linkedInFollowButton-module--linkedInFollowButton__box--74020";
export var linkedInFollowButton__mainButton = "linkedInFollowButton-module--linkedInFollowButton__mainButton--cbce2";
export var linkedInFollowButton__paragraph = "linkedInFollowButton-module--linkedInFollowButton__paragraph--56c72";